// extracted by mini-css-extract-plugin
export default {"componentWrapper":"InternalApplication_componentWrapper__yemvC"};